import React from "react";
import { Grid, Typography } from "@mui/material";

import { style } from "./style";

import GetImages from "@/components/GetImages";

import {
  IDoctorConsultationSelection,
  IDoctorConsultationType,
} from "@/models/doctor";
import { IAvailabilitySettingResult } from "@/models/ApiRequestResponse/doctor";

import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
  availabilitySettings,
  setSelectedAvailabilitySetting,
  setSelectedAvailabilitySettingDetail,
} from "@/store/slices/doctor/availabilitySettings";

const TotalAvailabilityCard: React.FC<IAvailabilitySettingResult> = (props) => {
  const { clinic_id, clinic_name, type_of_consultation, schedules } = props;

  const dispatch = useAppDispatch();
  const { selectedAvailabilitySetting } = useAppSelector(availabilitySettings);

  const handleSpecificAvailabilitySetting = () => {
    dispatch(setSelectedAvailabilitySetting(props));
    dispatch(setSelectedAvailabilitySettingDetail(null));
  };

  return (
    <Grid
      item
      key={clinic_id}
      sx={{
        backgroundColor: {
          md:
            selectedAvailabilitySetting?.clinic_id === clinic_id
              ? "var(--warm-neutral-50)!important"
              : "transparent",
        },
        ...style.container,
      }}
      onClick={handleSpecificAvailabilitySetting}
    >
      <Grid item sx={style.availabilityCommon}>
        <Grid item sx={style.titleIconContainer}>
          <GetImages
            name={
              type_of_consultation === IDoctorConsultationType.IN_CLINIC
                ? "ClinicIcon"
                : "VideoIcon"
            }
            width="20"
            height="20"
          />
          <Grid item sx={style.availabilityInfoContainer}>
            <Typography component={"h5"} sx={style.headerText}>
              {type_of_consultation === IDoctorConsultationType.IN_CLINIC
                ? clinic_name
                : IDoctorConsultationSelection.VIDEO_CONSULTATION}
            </Typography>
            <Grid item sx={style.availabilityCommon}>
              <Typography component={"p"} sx={style.totalAvailabilityText}>
                {schedules.length} Availability
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TotalAvailabilityCard;
